import type uz from './uz'

/** Russian. Typed against the Uzbek source so a missing key is a build error, not a blank label. */
const ru: typeof uz = {
  app: {
    name: 'Ombor',
    tagline: 'Система склада и дистрибуции',
  },
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    create: 'Создать',
    edit: 'Изменить',
    delete: 'Удалить',
    deleteConfirm: 'Удалить «{name}»? Запись исчезнет из списков, документы останутся в истории.',
    search: 'Поиск',
    loading: 'Загрузка…',
    unsavedWarning: 'Есть несохранённые изменения. Покинуть страницу?',
    draftFound: 'Найден несохранённый черновик.',
    restoreDraft: 'Восстановить',
    discardDraft: 'Удалить',
    print: 'Печать',
    undo: 'Отменить',
    retry: 'Повторить',
    close: 'Закрыть',
    yes: 'Да',
    no: 'Нет',
    actions: 'Действия',
    active: 'Активен',
    inactive: 'Неактивен',
    never: 'Никогда',
    back: 'Назад',
    of: 'из',
    total: 'Всего',
    post: 'Провести',
    confirm: 'Подтвердить',
    cancelDocument: 'Отменить документ',
    reason: 'Причина',
    note: 'Примечание',
    moreResults: 'Ещё {count} — уточните поиск',
    daysShort: '{n} дн.',
    leave: 'Уйти',
  },
  nav: {
    dashboard: 'Главная',
    warehouse: 'Склад',
    receipts: 'Приход',
    shipments: 'Расход',
    stock: 'Остатки',
    suppliers: 'Поставщики',
    agents: 'Агенты',
    stores: 'Магазины',
    payments: 'Касса',
    reports: 'Отчёты',
    settings: 'Настройки',
    users: 'Пользователи',
    sessions: 'Сессии',
    main: 'Главное меню',
    collapse: 'Свернуть меню',
    expand: 'Развернуть меню',
    search: 'Поиск',
    kassa: 'Касса',
    logout: 'Выйти',
    theme: 'Тема',
    language: 'Язык',
  },
  auth: {
    loginTitle: 'Вход в систему',
    loginSubtitle: 'Войдите в свою учётную запись',
    username: 'Логин',
    password: 'Пароль',
    rememberMe: 'Запомнить меня',
    submit: 'Войти',
    submitting: 'Вход…',
    loggedInAs: 'Вы вошли как',
    changePassword: 'Смена пароля',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    confirmPassword: 'Повторите новый пароль',
    passwordChanged: 'Пароль изменён. Войдите заново.',
    mustChangePassword: 'В целях безопасности смените пароль.',
    lockedUntil: 'Учётная запись заблокирована до {time}.',
    logoutAll: 'Выйти на всех устройствах',
    sessionsTitle: 'Активные сессии',
    currentSession: 'Текущее устройство',
    revokeSession: 'Завершить сессию',
    lastSeen: 'Начата',
    expiresAt: 'Истекает',
    device: 'Устройство',
    ipAddress: 'IP-адрес',
    revokeConfirm: 'Завершить эту сессию? На том устройстве придётся войти заново.',
    usernameRequired: 'Введите логин',
    passwordRequired: 'Введите пароль',
  },
  users: {
    title: 'Пользователи',
    create: 'Новый пользователь',
    edit: 'Изменить пользователя',
    fullName: 'Ф.И.О.',
    phone: 'Телефон',
    role: 'Роль',
    phoneHint: 'Telegram-бот узнаёт человека по этому номеру. Без номера вход в бота невозможен.',
    noPhone: 'нет номера',
    noPhoneWhy: 'Этот человек не сможет войти в Telegram-бота — номер не указан.',
    status: 'Статус',
    lastLogin: 'Последний вход',
    resetPassword: 'Сбросить пароль',
    resetPasswordHint:
      'Будет задан новый пароль и завершены все сессии пользователя. При первом входе он должен будет сменить пароль.',
    deactivate: 'Деактивировать',
    deactivateConfirm: 'Деактивировать «{name}»? Пользователь больше не сможет войти.',
    activate: 'Активировать',
    created: 'Пользователь создан',
    updated: 'Пользователь обновлён',
    passwordReset: 'Пароль сброшен. Завершено сессий: {count}.',
    empty: 'Пользователи не найдены.',
    searchPlaceholder: 'Поиск по логину или Ф.И.О.',
  },
  roles: {
    ADMIN: 'Директор',
    MANAGER: 'Менеджер',
    STOREKEEPER: 'Кладовщик',
    ACCOUNTANT: 'Бухгалтер',
    AGENT: 'Агент',
    VIEWER: 'Наблюдатель',
  },
  theme: {
    light: 'Светлая',
    dark: 'Тёмная',
    system: 'Системная',
  },
  table: {
    empty: 'Данные не найдены.',
    columns: 'Столбцы',
    density: 'Плотность',
    previous: 'Назад',
    next: 'Вперёд',
    clearFilters: 'Сбросить фильтры',
    range: '{start}–{end} из {total}',
  },
  currency: {
    UZS: 'сум',
  },
  validation: {
    invalidNumber: 'Неверное число',
    lineIncomplete: 'Строка не заполнена: {fields}',
    exceedsStock: 'Больше, чем есть на складе',
    fixLines: 'Строк с ошибками: {count}. Исправьте или удалите их.',
  },
  catalogue: {
    expiryTitle: 'Предупреждения о сроках',
    expiryHint: 'За сколько дней предупреждать. Кольца вложены: красное < жёлтое < наблюдение.',
    expiryWholeDays: 'Дни — целые числа больше нуля.',
    expiryRedBelowAmber: 'Красная граница должна быть меньше жёлтой.',
    expiryAmberBelowWatch: 'Жёлтая граница должна быть меньше границы наблюдения.',
    criticalDays: 'Красное (дней)',
    warningDays: 'Жёлтое (дней)',
    watchDays: 'Наблюдение (дней)',
    expirySaved: 'Границы сроков сохранены',
    products: 'Товары',
    newProduct: 'Новый товар',
    editProduct: 'Изменить товар',
    sku: 'Артикул',
    name: 'Наименование',
    barcode: 'Штрих-код',
    category: 'Категория',
    baseUnit: 'Базовая единица',
    baseUnitHint: 'Наименьшая продаваемая единица. Все остатки хранятся в ней.',
    baseUnitLocked: 'Базовую единицу изменить нельзя: у товара есть упаковка или движения.',
    defaultSalePrice: 'Цена продажи по умолчанию',
    minLevel: 'Минимальный остаток',
    maxLevel: 'Максимальный остаток',
    shelfLife: 'Срок годности (дней)',
    returnableFromStore: 'Можно вернуть из магазина',
    returnableToSupplier: 'Можно вернуть поставщику',
    note: 'Примечание',
    packaging: 'Единицы измерения и упаковка',
    packagingHint: 'Базовая единица присутствует автоматически. Здесь только упаковки.',
    packageUnit: 'Единица',
    packageFactor: 'Сколько базовых единиц',
    packageBarcode: 'Штрих-код',
    purchaseDefault: 'По умолчанию для прихода',
    saleDefault: 'По умолчанию для расхода',
    addPackage: 'Добавить упаковку',
    removePackage: 'Удалить',
    packagePreview: '1 {unit} = {factor} {base}',
    units: 'Единицы',
    categories: 'Категории',
    currencies: 'Валюты',
    rates: 'Курсы',
    warehouses: 'Склады',
    locations: 'Блоки',
    warehouseName: 'Название склада',
    warehouseAddress: 'Адрес',
    isDefault: 'Основной',
    makeDefault: 'Сделать основным',
    blockCode: 'Код блока',
    blockName: 'Название блока',
    addBlock: 'Добавить блок',
    noBlocks: 'В этом складе пока нет блоков',
    defaultHint: 'Если в документе склад не выбран, товар попадает сюда',
    code: 'Код',
    nameUz: 'Название (uz)',
    nameRu: 'Название (ru)',
    decimalPlaces: 'Знаков после запятой',
    symbol: 'Символ',
    isBase: 'Базовая',
    makeBase: 'Сделать базовой',
    makeBaseConfirm:
      'Сделать «{code}» базовой валютой? Все курсы и суммы будут считаться относительно неё.',
    rate: 'Курс',
    effectiveDate: 'Дата',
    setRate: 'Ввести курс',
    parent: 'Родительская категория',
    systemUnit: 'Системная единица',
    importTitle: 'Импорт из Excel',
    importHint: 'Сначала проверка (dry-run), затем подтверждение.',
    importPreview: 'Проверить',
    importConfirm: 'Подтвердить импорт',
    importResult: 'Будет создано: {created} · пропущено: {skipped}',
    importDone: 'Создано товаров: {created}.',
    importRow: 'Строка {row}',
  },
  parties: {
    storeStatus: {
      PENDING: 'Ждёт подтверждения',
      ACTIVE: 'Активен',
      CLOSED: 'Закрыт',
    },
    allStatuses: 'Все статусы',
    visitEvery: 'Периодичность визитов, дней',
    visitEveryHint: 'Пусто — общая норма (Настройки → Контроль агентов)',
    location: 'Расположение',
    locationHint:
      'Вставьте ссылку Google Maps или OpenStreetMap либо координаты: 41.311081, 69.240562',
    locationNow: 'Текущая отметка',
    locationMissing: 'Магазин ещё не отмечен на карте.',
    locationCheck: 'Проверьте на карте',
    locationUnreadable: 'Из этой ссылки не удалось прочитать координаты.',
    locationShortLink:
      'В сокращённой ссылке нет координат. Зажмите точку в Google Maps — появятся координаты, скопируйте их.',
    locationReplacesAgent: 'Внимание: отметка агента будет заменена.',
    placedByAgent: 'Отметил агент',
    placedByOffice: 'Отметил офис',
    confirmStore: 'Подтвердить',
    storeConfirmed: '«{name}» подтверждён',
    openedByAgent: 'Добавил агент',
    onMap: 'На карте',
    rating: 'Рейтинг',
    ratingLabel: 'Платёжный рейтинг: {stars} из 5',
    lateCount: 'Опозданий с оплатой: {count}',
    relocationPending: 'Сообщено о переезде',
    relocationTitle: 'Агент: магазин переехал',
    relocationDistance: '{m} м от прежнего места',
    relocationAccuracy: 'Точность GPS: ±{m} м',
    relocationAccept: 'Принять',
    relocationReject: 'Отклонить',
    relocationRejectConfirm: 'Отклонить сообщение? Место магазина не изменится.',
    relocationAccepted: 'Место магазина обновлено',
    relocationRejected: 'Сообщение отклонено',
    agentStatus: {
      ACTIVE: 'Активен',
      BLOCKED: 'Заблокирован',
      FIRED: 'Уволен',
    },
    assignmentReason: {
      INITIAL: 'Начальное',
      FIRED: 'Увольнение',
      REDISTRIBUTION: 'Перераспределение',
      PERFORMANCE: 'Показатели',
      VACATION: 'Отпуск',
    },
    changeStatus: 'Изменить статус',
    statusReason: 'Причина',
    statusReasonHint: 'Почему человек уходит с маршрута — через три месяца ответит эта запись.',
    statusChanged: 'Статус изменён',
    transfer: 'Передать магазины',
    transferTo: 'Кому',
    transferDate: 'С какой даты',
    transferNote: 'Комментарий',
    transferStores: 'Магазины для передачи',
    transferSummary: '{count} магазинов → {agent}',
    transferred: 'Передано магазинов: {count}',
    noStoresToTransfer: 'У этого агента нет магазинов.',
    selectAll: 'Выбрать все',
    agentHistory: 'История агентов',
    roundHistory: 'История магазинов',
    since: 'С',
    until: 'По',
    currentAssignment: 'Текущий',
    store: 'Магазин',
    suppliers: 'Поставщики',
    agents: 'Агенты',
    stores: 'Магазины',
    newSupplier: 'Новый поставщик',
    newAgent: 'Новый агент',
    newStore: 'Новый магазин',
    code: 'Код',
    fullName: 'Ф.И.О.',
    name: 'Название',
    phone: 'Телефон',
    phoneSecondary: 'Доп. телефон',
    address: 'Адрес',
    agent: 'Агент',
    pickUser: 'Выберите пользователя',
    nameFromAccount:
      'Имя и телефон берутся из учётной записи. Чтобы изменить их, отредактируйте пользователя.',
    creditLimit: 'Кредитный лимит',
    openingBalance: 'Начальный долг',
    openingBalanceHint: 'Долг из бумажных записей. С Phase 5 балансы считаются от него.',
    storeCount: 'Кол-во магазинов',
    note: 'Примечание',
  },
  warehouse: {
    margin: 'Маржа',
    updateCatalogue: 'Обновить и цену товара',
    draftSaved: 'Черновик сохранён',
    postedToast: '{number} проведён',
    receipts: 'Приход',
    newReceipt: 'Новый приход',
    editReceipt: 'Изменить приход',
    stock: 'Остатки',
    docNumber: '№ документа',
    batch: 'Партия',
    date: 'Дата',
    supplier: 'Поставщик',
    lines: 'Позиции',
    totalAmount: 'Сумма',
    currency: 'Валюта',
    status: 'Статус',
    createdBy: 'Создал',
    product: 'Товар',
    quantity: 'Количество',
    unit: 'Ед. изм.',
    unitConversion: '{entered} = {base}',
    purchasePrice: 'Цена прихода',
    salePrice: 'Цена продажи',
    perBase: '{price} / {unit}',
    productionDate: 'Дата производства',
    expiryDate: 'Годен до',
    expiryEstimated: 'Приблизительно — дата с упаковки не введена',
    warehouseLabel: 'Склад',
    block: 'Блок',
    blockNone: 'Без блока',
    lineTotal: 'Сумма строки',
    addLine: 'Добавить строку',
    removeLine: 'Удалить',
    duplicateLine: 'Дублировать',
    conversionHint: '{quantity} {unit} = {base} {baseUnit}',
    saveDraft: 'Сохранить черновик',
    post: 'Провести',
    postConfirm: 'После проведения на склад поступит {total}. Документ станет неизменяемым.',
    cancelDoc: 'Отменить',
    cancelDocument: 'Отменить документ',
    chooseProductFirst: 'Сначала выберите товар',
    cancelReason: 'Причина отмены',
    cancelHint: 'Причина обязательна. Документ не удаляется — создаются обратные записи.',
    totalQuantity: 'Всего количество',
    potentialMargin: 'Ожидаемая прибыль',
    batches: 'Партии',
    movements: 'Движение склада',
    audit: 'Аудит',
    batchNumber: '№ партии',
    received: 'Поступило',
    remaining: 'Остаток',
    allWarehouses: 'Все',
    moveToBlock: 'Переместить в блок',
    blockMoved: 'Партия перемещена в блок {code}',
    movementType: 'Тип',
    occurredAt: 'Дата',
    unitCost: 'Себестоимость',
    quantityOnHand: 'Остаток',
    reserved: 'Зарезервировано',
    available: 'Доступно',
    stockValue: 'Стоимость',
    batchCount: 'Партий',
    nearestExpiry: 'Ближайший срок',
    level: 'Статус',
    daysLeft: 'Осталось {days} дн.',
    expiredDays: 'Просрочено {days} дн.',
    noExpiry: 'Без срока',
    scanHint: 'Название, артикул или штрих-код',
    emptyReceipts: 'Приходов пока нет. Создайте первый.',
    emptyStock: 'На складе пока нет товаров.',
  },
  docStatus: {
    DRAFT: 'Черновик',
    POSTED: 'Проведён',
    CANCELLED: 'Отменён',
  },
  movementType: {
    RECEIPT: 'Приход',
    SHIPMENT: 'Расход',
    RETURN_IN: 'Возврат (приход)',
    RETURN_OUT: 'Возврат (расход)',
    WRITE_OFF: 'Списание',
    ADJUSTMENT: 'Корректировка',
    REVERSAL: 'Сторно',
  },
  stockLevel: {
    OUT: 'Закончился',
    LOW: 'Мало',
    NORMAL: 'Достаточно',
    OVER: 'Избыток',
  },
  expiry: {
    EXPIRED: 'Просрочено',
    CRITICAL: 'Очень скоро',
    WARNING: 'Приближается',
    WATCH: 'Под наблюдением',
    OK: 'Хорошо',
  },
  writeOff: {
    title: 'Списание',
    new: 'Новое списание',
    empty: 'Списаний нет',
    reasonLabel: 'Причина',
    reason: {
      EXPIRED: 'Просрочено',
      DAMAGED: 'Повреждено',
      LOST: 'Утеряно',
      INTERNAL: 'Внутренние нужды',
      OTHER: 'Другое',
    },
    loss: 'Сумма потерь',
    issuedTo: 'Кому выдано',
    issuedToStaff: 'Сотрудник',
    issuedToStaffHint: 'Выберите из списка — тогда долг и зарплата будут в одном месте',
    issuedToStaffPlaceholder: 'Выберите сотрудника',
    asDebt: 'Выдано в долг',
    asDebtHint:
      'Себестоимость запишется в долг этому человеку и может быть удержана из зарплаты. Без галочки — за счёт компании.',
    issuedToHint:
      'Имя или подразделение: «Директор — домой», «Офис», «Водитель Алишер». Обязательно — расход без имени превращается в необъяснимую потерю.',
    unitCost: 'Себестоимость',
    batchHint: 'Партию выбираете вы — система не выбирает за вас.',
    draftHint: 'Сначала сохраняется черновик. До проведения со склада ничего не списывается.',
    posted: '{number} проведён',
    cancelled: 'Списание отменено',
    cancelHint: 'Товар вернётся в свою партию с её сроком годности.',
  },
  return: {
    quarantine: 'Карантин',
    quarantineHint:
      'Возврат из магазина ждёт здесь: товар на складе, но не продаётся. Осмотрите и выберите один из трёх путей.',
    quarantineEmpty: 'В карантине пусто.',
    backOnSale: 'Обратно в продажу',
    restocked: 'Товар вернулся в продажу',
    title: 'Возвраты',
    new: 'Новый возврат',
    empty: 'Возвратов нет',
    directionLabel: 'Направление',
    direction: {
      FROM_STORE: 'От магазина',
      TO_SUPPLIER: 'Поставщику',
    },
    party: 'Контрагент',
    unitPrice: 'Цена',
    perBaseHint: '1 {unit} = {price}',
    batchHint: 'Возвращённый товар вернётся в свою партию с её сроком годности.',
    posted: '{number} проведён',
    cancelled: 'Возврат отменён',
    cancelHint: 'Склад и долг возвращаются вместе. Оба документа остаются в истории.',
    override: 'Превысить лимит',
    overrideHint:
      'Магазин возвращает больше, чем получил из этой партии. Только директор может провести это с указанием причины; запись попадёт в журнал аудита. Товар оформляется как новая партия.',
  },
  adjustment: {
    title: 'Корректировки',
    subtitle: 'Расхождение инвентаризации. Только директор, с причиной.',
    new: 'Новая корректировка',
    empty: 'Корректировок нет',
    delta: 'Разница',
    deltaHint: 'Отрицательное число уменьшает, положительное увеличивает. Например: -3',
    reasonHint: 'Минимум 5 символов. Этой причиной объясняется изменение числа.',
    posted: '{number} записан',
  },
  kpi: {
    title: 'KPI',
    metricLabel: 'Показатель',
    deleteConfirm: 'Удалить план? Все его месячные части тоже исчезнут.',
    collapse: 'Свернуть',
    expand: 'Развернуть',
    yearTarget: 'План на год',
    setTarget: 'Задать план',
    weight: 'Вес',
    weightHint:
      'Насколько этот показатель учитывается в месячной оценке KPI; каждый показатель ограничивается 100 %',
    target: 'План',
    fact: 'Факт',
    percent: 'Процент',
    split: 'Разбить по месяцам',
    empty: 'План не задан.',
    half: '{index}-е полугодие',
    quarter: '{index}-й квартал',
    metric: {
      SHIPPED: 'Отгружено',
      COLLECTED: 'Собрано',
      COLLECTION_RATE: 'Процент сбора',
      NEW_STORES: 'Новые магазины',
      VISITS: 'Визиты',
      ACTIVE_STORES: 'Активные магазины',
      OVERDUE_DEBT: 'Просроченный долг',
    },
    month: {
      1: 'Январь',
      2: 'Февраль',
      3: 'Март',
      4: 'Апрель',
      5: 'Май',
      6: 'Июнь',
      7: 'Июль',
      8: 'Август',
      9: 'Сентябрь',
      10: 'Октябрь',
      11: 'Ноябрь',
      12: 'Декабрь',
    },
  },
  salary: {
    title: 'Расчёт зарплаты',
    newScheme: 'Добавить схему',
    editScheme: 'Изменить схему',
    noScheme: 'Схема для этого сотрудника не задана.',
    validFrom: 'С какой даты',
    validFromHint: 'Зарплаты за месяцы с этой даты считаются по этой схеме',
    payable: 'Итого (без аванса)',
    apply: 'Подставить эти суммы',
    overdueInfoTitle: 'Просроченные долги — для сведения, решает руководитель',
    field: {
      base_salary: 'Оклад',
      sales_pct: 'От отгрузки, %',
      collection_pct: 'От собранных денег, %',
      new_store_bonus: 'За новый магазин',
      kpi_bonus: 'Премия за KPI',
      kpi_bonus_min_pct: 'Минимум для премии KPI, %',
      visit_min_pct: 'Минимум плана визитов, %',
      visit_penalty: 'Штраф за визиты',
    },
    line: {
      base: 'Оклад',
      sales: 'Премия с отгрузки',
      collection: 'Премия со сбора',
      newStores: 'За новые магазины',
      kpi: 'Премия за KPI',
      visitPenalty: 'План визитов не выполнен',
      overdueInfo: 'Просроченный долг',
    },
    basis: {
      amount: 'Сумма',
      pct: 'Процент',
      count: 'Количество',
      each: 'За каждый',
      average: 'Среднее',
      minimum: 'Минимум',
      done: 'Выполнено',
      returned: 'Возвращено',
      store: 'Магазин',
      days: '{n} дн.',
    },
  },
  settings: {
    field: {
      tab: 'Контроль агентов',
      title: 'Настройки контроля агентов',
      lede: 'Работа агента измеряется этими настройками. Изменения действуют с первого же обновления экрана — ничего не пересчитывается.',
      radius: 'Радиус магазина, м',
      radiusHint:
        'Заказ внутри этого круга считается записанным в магазине. Точность телефона добавляется сверху (не более 50 м)',
      overdueDays: 'Забытый магазин, дней',
      overdueHint: 'Магазин, куда не заходили столько дней, попадает в список забытых',
      newLimit: 'Кредит нового магазина',
      newLimitHint:
        'Магазин, открытый агентом из бота, начинает с этим лимитом — решение о кредите не принимается на пороге',
      blocks: 'Отклонять заказ, записанный вдали',
      blocksHint:
        'Сейчас выключено: заказ проходит и лишь помечается. Если включить, заказ вне радиуса не пройдёт вовсе — в день плохого GPS агент не сможет работать. Освобождённые агенты — исключение.',
      wholeNumbers: 'Радиус, число дней и точность GPS — целые числа больше нуля.',
      maxAccuracy: 'Предел точности GPS, м',
      maxAccuracyHint:
        'Если при отметке магазина точность телефона хуже этой, отметка отклоняется. Решение владельца: 20 м — у двери, а не через дорогу',
      newStoreBonus: 'Начислять оплату за новый магазин',
      newStoreBonusHint:
        'Если включено, сумма «за новый магазин» из схемы зарплаты начисляется в месяце, когда офис подтвердил магазин. Пока выключено',
      saved: 'Настройки сохранены',
    },
  },
  supervision: {
    title: 'Контроль',
    subtitle: 'Где агенты были сегодня',
    today: 'Визиты за день',
    overdue: 'Забытые магазины',
    anomalies: 'Подозрительные',
    at: 'Время',
    day: 'Дата',
    distance: 'Расстояние',
    outcome: 'Результат',
    metres: '{distance} м',
    orders: 'Заказов: {count}',
    nothingCameOfIt: 'Заказа не было',
    lastSeen: 'Последний визит',
    daysAgo: 'Дней назад',
    daysOf: '{days} дн. (норма: {of})',
    neverVisited: 'Ни разу не были',
    storeCount: 'Магазинов',
    storesInAMinute: '{count} магазина за минуту',
    noVisits: 'В этот день визитов нет.',
    noOverdue: 'Забытых магазинов нет.',
    noAnomalies: 'Подозрительных визитов нет.',
    reason: {
      CLOSED: 'Был закрыт',
      NO_NEED: 'Товар не нужен',
      NO_MONEY: 'Нет денег',
      OWNER_AWAY: 'Хозяина не было',
      OTHER: 'Другая причина',
    },
  },
  order: {
    waitingTitle: 'Запросы, ожидающие ответа: {count}',
    confirm: 'Подтвердить',
    confirmed: 'Заказ подтверждён — товар зарезервирован',
    title: 'Заказы',
    new: 'Новый заказ',
    edit: 'Изменить заказ',
    empty: 'Заказов нет',
    openOnly: 'Ожидают ответа',
    offSite: 'Записан вдали от магазина',
    offSiteOnly: 'Только записанные вдали',
    writtenAtShop: 'Записан в магазине',
    metresAway: '{distance} м от магазина',
    whereWritten: 'Где записан',
    notMeasured: 'Не измерено',
    allOrders: 'Все',
    available: 'Доступно',
    reserved: 'Зарезервировано',
    expectedDate: 'Ожидаемая дата',
    overAvailable: 'Можно заказать не более {available}',
    accept: 'Принять',
    accepted: 'Заказ принят',
    reject: 'Отклонить',
    closed: 'Заказ закрыт',
    closeHint:
      'Причину сообщат магазину, и она остаётся в документе. Заказ не удаляется — он закрывается, а резерв освобождается.',
    makeShipment: 'Создать отгрузку',
    shipmentMade: 'Отгрузка',
    formHint: 'Заказ не меняет склад. Это только запрос — товар уходит при проведении отгрузки.',
    status: {
      REQUESTED: 'Запрос',
      NEW: 'Новый',
      ACCEPTED: 'Принят',
      FULFILLED: 'Выполнен',
      REJECTED: 'Отклонён',
      CANCELLED: 'Отменён',
      EXPIRED: 'Просрочен',
    },
  },
  expense: {
    title: 'Расходы',
    subtitle: 'Аренда, коммуналка, ремонт — расходы, не связанные с товаром',
    new: 'Новый расход',
    empty: 'Расходов нет',
    month: 'Месяц',
    newAdvance: 'Выдать аванс',
    allKinds: 'Все',
    staff: '(сотрудник)',
    staffPayee: 'Сотрудник',
    staffPayeeHint: 'Выберите из списка — потом можно отфильтровать по этому человеку',
    salaryPayeeHint: 'Для зарплаты сотрудник обязателен — система должна знать, кому выдано',
    advanceHint:
      'Запишется как аванс: в разделе Зарплаты он автоматически вычтется из зарплаты этого человека.',
    staffPlaceholder: 'Выберите сотрудника (необязательно)',
    category: 'Категория',
    paidTo: 'Кому оплачено',
    paidToHint: 'Арендодатель, газслужба, мастер',
    totalSpent: 'Всего потрачено',
    recorded: '{number} записан',
    notAPaymentHint:
      'Внимание: оплата поставщику за ТОВАР сюда не записывается — она в «Кассе». Записав дважды, вы вдвое занизите прибыль.',
  },
  payroll: {
    title: 'Зарплата',
    subtitle: 'По каждому сотруднику: оклад, премия и удержание',
    employees: 'Сотрудники',
    newEmployee: 'Новый сотрудник',
    employee: 'Сотрудник',
    position: 'Должность',
    baseSalary: 'Оклад',
    owes: 'Долг',
    owesHint: 'Сотрудник должен {amount}. Удерживать не обязательно.',
    paidOut: 'Выплачено',
    pay: 'Выплатить',
    finish: 'Продолжить',
    paid: '{number} выплачен',
    done: 'Выплачено',
    empty: 'Сотрудников нет',
    monthTotal: 'За месяц',
    bonus: 'Премия',
    bonusNote: 'Комментарий',
    deduction: 'Удержание',
    advance: 'Аванс',
    overAdvanced: 'Выданный аванс больше заработанного за месяц',
    tooMuch: 'Нельзя удержать больше долга',
    net: 'К выдаче',
    earnedHint: 'В расход идёт оклад + премия — столько заработано. Удержанное гасит долг.',
    scoreTitle: 'Для премии — показатели агента',
    shipped: 'Отгружено',
    collected: 'Собрано',
    outstanding: 'Остаток долга',
    overdue90: '90+ дней',
    agentHint: 'Если выбран агент, при выплате показываются его показатели.',
  },
  shipment: {
    postedToast: '{number} проведён',
    title: 'Расход',
    newShipment: 'Новый расход',
    editShipment: 'Изменить расход',
    store: 'Магазин',
    agent: 'Агент',
    dueDate: 'Срок оплаты',
    duePresets: '7 дней / 14 дней / 30 дней',
    balance: 'Текущий долг',
    creditLimit: 'Кредитный лимит',
    headroom: 'Остаток лимита',
    noLimit: 'Без лимита',
    projected: 'После расхода',
    available: 'Доступно',
    availableBatches: 'Доступные партии',
    fromWarehouse: 'С какого склада',
    anyWarehouse: 'С любого склада',
    pinWarehouse: 'Только с этого склада',
    allocations: 'По партиям',
    allocation: 'Из какой партии',
    cogs: 'Себестоимость',
    margin: 'Прибыль',
    marginPercent: 'Прибыль %',
    unitChanged: 'Единица изменена — цена пересчитана',
    allowExpired: 'Использовать и просроченные партии',
    overrideCreditLimit: 'Разрешить превышение лимита',
    adminOnly: 'Только директор',
    overdueOnly: 'Просроченные',
    postConfirm:
      'После проведения со склада уйдут {count} позиц., долг {store} вырастет на {total}.',
    emptyShipments: 'Расходов пока нет. Создайте первый.',
    print: 'Печать',
    deliveryNote: 'Накладная',
    warnings: 'Предупреждения',
  },
  warn: {
    near_expiry: 'У партии {batch} осталось {days_left} дн. до конца срока годности.',
    expired_skipped:
      '{product}: пропущено просроченных партий: {count} ({quantity}) — их нужно списать.',
    credit_limit_overridden:
      '{store} превысил кредитный лимит ({limit}) — {projected}. Разрешил: {by}.',
  },
  finance: {
    shipped: 'Отгружено',
    collected: 'Собрано',
    balance: 'Долг',
    supplier: 'Поставщик',
    store: 'Магазин',
    agent: 'Агент',
    party: 'Контрагент',
    goodsReceived: 'Полученные товары',
    goodsShipped: 'Отгруженные товары',
    paymentsGiven: 'Выплаченные платежи',
    documentsCount: '{count} документов',
    paymentsCount: '{count} платежей',
    theyOweUs: 'Нам должны',
    weOweThem: 'Наш долг',
    settled: 'Долга нет',
    lastMovement: 'Последнее движение',
    amount: 'Сумма',
    methodLabel: 'Тип оплаты',
    paidAt: 'Дата',
    paidOn: 'День выплаты',
    comment: 'Комментарий',
    commentHint: 'Необязательно',
    balanceBefore: 'Остаток (до)',
    balanceAfter: 'Остаток (после)',
    recordPayment: 'Сохранить платёж',
    cancelPayment: 'Отменить платёж',
    cancelReason: 'Причина отмены',
    cancelReasonHint: 'Например: введено дважды',
    docNumber: 'Документ №',
    date: 'Дата',
    document: 'Документ',
    note: 'Примечание',
    debit: 'Дебет',
    credit: 'Кредит',
    runningBalance: 'Остаток',
    openingBalance: 'Начальный остаток',
    oldestIsOpening: 'Начальный остаток',
    closingBalance: 'Конечный остаток',
    dateFrom: 'С даты',
    dateTo: 'По дату',
    exportExcel: 'Excel',
    direction: 'Направление',
    incoming: 'Приход',
    outgoing: 'Расход',
    paymentIn: 'Поступление',
    paymentOut: 'Выплата',
    allDirections: 'Все',
    allMethods: 'Все типы',
    total: 'Итого',
    totalQuantity: 'Общее количество',
    averagePrice: 'Средняя цена',
    lastPrice: 'Последняя цена',
    lastPurchase: 'Последний приход',
    shippedTotal: 'Всего отгружено',
    collectedTotal: 'Собрано платежей',
    exposure: 'Остаток долга',
    storesServed: 'Магазины',
    debt: 'Долг',
    oldestUnpaid: 'Самый старый неоплаченный документ',
    daysOverdue: 'Дней просрочки',
    collectionRate: 'Уровень сбора',
    averageCollectionDays: 'Средний срок сбора (дней)',
    payToSupplier: 'Оплата поставщику',
    collectFromStore: 'Оплата от магазина',
    chooseSupplier: 'Выберите поставщика',
    chooseSupplierFirst: 'Сначала выберите поставщика.',
    collectedFrom: 'Из какого магазина',
    chooseStore: 'Выберите магазин',
    chooseStoreFirst: 'Сначала выберите магазин — деньги всегда относятся к его долгу.',
    documentsCountShort: 'Документы',
    receivablesAging: 'Возраст задолженности',
    method: {
      CASH: 'Наличные',
      CLICK: 'Click',
      TRANSFER: 'Перевод',
      CARD: 'Карта',
    },
    docType: {
      goods_receipt: 'Приход',
      shipment: 'Расход',
      payment: 'Платёж',
      OPENING: 'Начальный остаток',
    },
    aging: {
      not_due: 'Срок не наступил',
      d1_30: '1–30 дней',
      d31_60: '31–60 дней',
      d61_90: '61–90 дней',
      d90_plus: '90+ дней',
    },
    tab: {
      receipts: 'Приходы',
      shipments: 'Расходы',
      payments: 'Платежи',
      kassa: 'Касса',
      statement: 'Отчёт',
      products: 'Товары',
      stores: 'Магазины',
      performance: 'Эффективность',
    },
  },
  goLive: {
    title: 'Переход на систему',
    intro:
      'Бумажные остатки и долги вводятся в систему как документы. Перед блокировкой сверьте три суммы с вашими записями.',
    step1: 'Шаг 1 · Дата перехода',
    step2: 'Шаг 2 · Итоговая проверка',
    step3: 'Шаг 3 · Блокировка',
    dateLabel: 'Дата перехода',
    saveDate: 'Сохранить',
    openingStock: 'Стоимость начального остатка',
    stockDetail: '{batches} партий · {products} товаров',
    totalReceivable: 'Нам должны (магазины)',
    totalPayable: 'Наш долг (поставщики)',
    storesCount: '{count} магазинов',
    suppliersCount: '{count} поставщиков',
    lockHint:
      'После блокировки начальные документы может менять только директор. Для подтверждения введите обе суммы вручную.',
    confirmReceivable: 'Введите сумму «Нам должны»',
    confirmPayable: 'Введите сумму «Наш долг»',
    lockButton: 'Заблокировать',
    locked: 'Переход заблокирован {date}.',
  },
  dashboard: {
    vsPreviousPeriod: 'По сравнению с прошлым периодом',
    openList: 'Открыть список',
    overdue90: '90+ дней',
    inQuarantine: 'Из них в карантине',
    valueAtRisk: 'Сумма под риском',
    daysLeft: 'Осталось дней',
    daysCounted: '{count} дней',
    goodsIn: 'Приход',
    goodsOut: 'Расход',
    revenue: 'Выручка',
    cogs: 'Себестоимость',
    grossProfit: 'Валовая прибыль',
    margin: 'Маржа',
    deadStock: 'Без движения',
    period: {
      today: 'Сегодня',
      week: '7 дней',
      month: '30 дней',
      quarter: 'Квартал',
      year: 'Год',
      custom: 'Период',
    },
    measure: { amount: 'Сумма', quantity: 'Количество' },
    kpi: {
      stock_value: 'Стоимость склада',
      receivable: 'Нам должны',
      payable: 'Наш долг',
      net_position: 'Чистая позиция',
      period_in: 'Приход',
      period_out: 'Расход',
    },
    otherCosts: 'Внутренний расход и потери',
    openOrders: 'Открытые заказы',
    orderValue: 'Сумма заказов',
    awaitingAnswer: 'Ждут ответа',
    reservedProducts: 'Резерв по {count} товарам',
    monthWages: 'Зарплаты за месяц',
    paidSoFar: 'Выплачено',
    staffDebt: 'Долг сотрудников',
    staffDebtHint: 'Товар, взятый в долг — закрывается удержанием из зарплаты',
    card: {
      expiry: 'Сроки годности',
      lowStock: 'Мало на складе',
      overstock: 'Избыточный запас',
      dynamics: 'Динамика прихода/расхода',
      storeDebt: 'Долги магазинов',
      agentDebt: 'Долги по агентам',
      topProducts: 'Топ товаров',
      profit: 'Прибыль',
      orders: 'Заказы',
      staff: 'Касса сотрудников',
      overdue: 'Просроченные платежи',
      turnover: 'Оборачиваемость',
      activity: 'Последние действия',
      collection: 'Сбор денег',
      overLimit: 'Превысили кредитный лимит',
      dormant: 'Уснувшие магазины',
      fillRate: 'Исполнение заказов',
      frozen: 'Замороженные деньги',
    },
    collected: 'собрано',
    shippedOnCredit: 'Отгружено в долг',
    cameToKassa: 'Поступило в кассу',
    notYetCollected: 'Не собрано за период',
    outstandingAll: 'Общий долг (за всё время)',
    overLimitHint: 'Этим магазинам нужно приостановить отгрузку',
    nobodyOverLimit: 'Никто не превысил лимит.',
    overBy: 'Превышение',
    dormantHint: 'Нет заказов уже {days} дней',
    everybodyBuying: 'Все магазины активны.',
    lastOrder: 'Последняя отгрузка',
    quietFor: 'Тишина',
    lastYearValue: 'Оборот за год',
    days: '{n} дн.',
    fillRateHint: 'Запрошено и отгружено',
    noOrdersInPeriod: 'За период заказов не было.',
    ofOrders: 'выполнено {done} из {all}',
    ordered: 'Запрошено',
    shipped: 'Отгружено',
    stillOpen: 'Открыто: {n}',
    lost: 'Потеряно: {n}',
    frozenHint: 'Без движения {days} дней',
    everythingMoving: 'Весь товар в движении.',
    frozenTotal: 'лежит на складе',
  },
  reports: {
    'stock-valuation': 'Стоимость склада',
    expiry: 'Сроки годности',
    'receivables-aging': 'Возраст задолженности',
    payables: 'Долги поставщикам',
    sales: 'Продажи',
    profit: 'Прибыль',
    'net-profit': 'Чистая прибыль',
    averageCost: 'Средняя себестоимость',
    value: 'Стоимость',
    expiryDate: 'Срок годности',
    bucket: 'Раздел',
    name: 'Название',
    inQuarantine: 'Из них в карантине',
    quarantineLots: 'партий: {n}',
    groupBy: {
      product: 'По товару',
      store: 'По магазину',
      agent: 'По агенту',
      month: 'По месяцу',
    },
  },
  netProfit: {
    revenue: 'Выручка',
    cogs: 'Себестоимость',
    gross: 'Валовая прибыль',
    marginHint: 'маржа {percent}',
    expenses: 'Расходы',
    expensesHint: 'аренда, зарплаты, коммунальные — зарплаты уже включены',
    internal: 'Внутренний расход',
    internalHint: 'выданное безвозмездно — выданное в долг сюда не входит',
    losses: 'Потери',
    net: 'ЧИСТАЯ ПРИБЫЛЬ',
    netHint: '{percent} от выручки',
    chargedHint: 'Товар, выданный сотрудникам в долг (не в отчёте — числится за ними):',
  },
  company: {
    title: 'Данные компании',
    subtitle: 'Печатается на документах и показывается в боковой панели. Заполняется один раз.',
    name: 'Название компании',
    nameHint: 'Короткое название — в шапке документа',
    legalName: 'Полное юридическое название',
    address: 'Адрес',
    phone: 'Телефон',
    email: 'Электронная почта',
    taxId: 'ИНН',
    bank: 'Банковские реквизиты',
    bankName: 'Название банка',
    bankAccount: 'Расчётный счёт',
    logo: 'Логотип',
    noLogo: 'Логотип не задан',
    removeLogo: 'Удалить',
    logoHint: 'PNG, JPG или SVG. Не больше {limit} КБ — это шапка, а не фотография.',
    logoTooBig: 'Файл слишком большой. До {limit} КБ.',
    saved: 'Данные компании сохранены',
  },
  palette: {
    title: 'Командная панель',
    placeholder: 'Экран, товар, магазин или поставщик…',
    group: { screen: 'Экран', product: 'Товар', store: 'Магазин', supplier: 'Поставщик' },
  },
  shortcuts: {
    title: 'Горячие клавиши',
    global: 'Общие',
    documents: 'Формы документов',
    tables: 'Таблицы',
    palette: 'Командная панель',
    sheet: 'Список горячих клавиш',
    close: 'Закрыть',
    saveDraft: 'Сохранить черновик',
    post: 'Провести',
    newLine: 'Новая строка',
    moveRow: 'Перемещение по строкам',
    openRow: 'Открыть строку',
  },
  print: {
    company: 'OMBOR ООО',
    companyAddress: 'г. Ташкент, основной склад',
    counterparty: 'Контрагент',
    printedAt: 'Напечатано',
    receipt: 'Приходный документ',
    deliveryNote: 'Накладная',
    statement: 'Акт сверки',
    paymentReceipt: 'Квитанция об оплате',
    signedBy: 'Сдал',
    receivedBy: 'Принял',
    accountant: 'Бухгалтер',
  },
  errors: {
    AGENT_NOT_DISMISSABLE:
      'Нельзя уволить: магазины не переданы другому агенту или не закрыта зарплата.',
    PAYROLL_EXPENSE_LOCKED: 'Этот расход создан ведомостью зарплаты; отменить его отдельно нельзя.',
    SHOP_PHONE_SHARED: 'Этот номер записан за несколькими магазинами. Обратитесь в офис.',
    apiUnreachable: 'Нет связи с сервером. Изменения не сохраняются.',
    title: 'Ошибка',
    INVALID_CREDENTIALS: 'Неверный логин или пароль',
    ACCOUNT_LOCKED: 'Учётная запись временно заблокирована. Попробуйте позже.',
    ACCOUNT_INACTIVE: 'Эта учётная запись отключена. Обратитесь к администратору.',
    INVALID_TOKEN: 'Сессия истекла. Войдите заново.',
    TOKEN_REUSE_DETECTED: 'Из соображений безопасности все сессии завершены. Войдите заново.',
    CSRF_FAILED: 'Запрос не подтверждён. Обновите страницу.',
    PERMISSION_DENIED: 'У вас нет прав на это действие.',
    PASSWORD_CHANGE_REQUIRED: 'Сначала смените временный пароль.',
    CANCEL_WINDOW_CLOSED:
      'С момента проведения документа прошло больше 24 часов — теперь отменить его может только директор.',
    CANCEL_DIRECTOR_ONLY: 'Этот документ может отменить только директор.',
    NOT_FOUND: 'Не найдено.',
    CONFLICT: 'Такая запись уже существует.',
    WEAK_PASSWORD: 'Пароль не отвечает требованиям.',
    RATE_LIMITED: 'Слишком много попыток. Подождите немного.',
    VALIDATION_ERROR: 'В данных есть ошибка.',
    SERVICE_UNAVAILABLE: 'Сервер не отвечает.',
    NETWORK: 'Не удалось подключиться к серверу.',
    ORDER_STATE: 'Текущее состояние заказа не допускает это действие.',
    NOT_AT_THE_SHOP: 'Вы не в магазине «{store}»: расстояние {distance_m} м.',
    PRICE_CHANGED: 'Цена «{product}» изменилась: показано {shown}, сейчас {current}.',
    KPI_PLAN_SHAPE: 'План KPI не соответствует периоду или его части не сходятся с итогом.',
    TRANSFER_DATE_IN_FUTURE: 'Дата передачи не может быть в будущем: {effective_date}.',
    TRANSFER_DATE_TOO_EARLY:
      '«{store}» закреплён за текущим агентом с {since}; дата передачи должна быть позже (не раньше {earliest}).',
    SCHEME_MONTH_PAID:
      'Зарплата за {month} уже проведена (по {paid_through}). Запишите схему со следующего месяца.',
    LOCATION_ALREADY_SET:
      'Позиция «{store}» уже отмечена. Если магазин переехал, сообщите руководителю.',
    LOCATION_PROPOSAL_PENDING: 'По этому магазину уже ожидает сообщение о переезде.',
    LOCATION_PROPOSAL_DECIDED: 'По этому сообщению решение уже принято ({status}).',
    LOCATION_TOO_COARSE:
      'Точность GPS недостаточна ({accuracy_m} м, допустимо {limit_m} м). Отправьте ещё раз у двери магазина.',
    PRODUCT_UNPRICED: 'У «{product}» нет цены — магазин не может его заказать.',
    ORDER_POSITION_REQUIRED:
      'Заказ для «{store}» принимается только у магазина: отправьте своё местоположение.',
    OFF_SITE_ORDER: 'Заказ записан в {distance_m} м от магазина. Допустимый радиус: {radius_m} м.',
    NOT_ENOUGH_TO_PROMISE:
      'Запрошено больше, чем можно обещать: доступно {available}, запрошено {requested}.',
    INSUFFICIENT_BATCH: 'В партии «{batch}» есть {available}, запрошено {requested}.',
    RETURN_EXCEEDS_DELIVERY:
      'Магазин получил {delivered} из партии «{batch}» и вернул {already_returned} — можно вернуть ещё {available}, запрошено {requested}.',
    DOCUMENT_STATE: 'Текущее состояние документа не допускает это действие.',
    PAYMENT_STATE: 'Текущее состояние платежа не допускает это действие.',
    GO_LIVE_LOCKED: 'Переход в систему заблокирован. Изменения — только через директора.',
    GO_LIVE_NOT_READY: 'Переход в систему ещё не завершён.',
    IDEMPOTENCY_CONFLICT: 'Этот запрос уже был отправлен с другими данными.',
    INSUFFICIENT_STOCK: 'На складе недостаточно товара.',
    CREDIT_LIMIT_EXCEEDED: 'Превышен кредитный лимит.',
    INVALID_DOCUMENT_STATE: 'Статус документа не допускает это действие.',
    DOCUMENT_HAS_NO_LINES: 'В документе нет строк.',
    BATCH_ALREADY_CONSUMED:
      'Часть этих товаров уже покинула склад. Сначала отмените эти документы: {documents}',
    MISSING_EXCHANGE_RATE: 'На эту дату курс не введён.',
    FRACTIONAL_BASE_UNIT: 'В этой единице дробное количество недопустимо.',
    BASE_UNIT_LOCKED: 'Базовую единицу изменить нельзя.',
    ENTITY_IN_USE: 'Запись используется — удалить нельзя.',
    BATCH_PRODUCT_MISMATCH:
      'Партия «{batch}» относится к другому товару. Выберите партию этого товара.',
    BATCH_BLOCKED: 'Партия «{batch}» из отменённого прихода — добавить в неё товар нельзя.',
    BATCH_OVER_RECEIVED:
      'В партию «{batch}» поступило {received}, сейчас в ней {remaining} — если добавить {requested}, будет больше, чем поступило. Оформите излишек новым приходом.',
    RETURNS_EXIST:
      'Магазин вернул часть товара из этой отгрузки. Сначала отмените эти возвраты: {documents}',
    PARTY_HAS_BALANCE:
      'Остаток по этому контрагенту {balance} — удалить нельзя, пока расчёты не закрыты.',
    SYSTEM_ENTITY: 'Системная запись — удалить нельзя.',
    DEFAULT_WAREHOUSE: 'Основной склад нельзя удалить или снять — сначала назначьте другой.',
    NO_STOCK_TO_REMOVE: 'Нет остатка для списания.',
    IMPORT_FILE_INVALID: 'Файл не прочитан.',
    ADVANCE_EXCEEDS_EARNINGS:
      'За этот месяц уже выдан аванс {advance} — эта зарплата ({earned}) меньше него.',
    AGENT_REQUIRED: 'Выберите агента, который принёс деньги.',
    BASE_CURRENCY_RATE: 'Курс базовой валюты всегда 1 — его нельзя ввести.',
    BASE_CURRENCY_REQUIRED: 'Базовая валюта обязательна — сначала сделайте базовой другую валюту.',
    BASE_UNIT_AS_PACKAGE: 'Базовую единицу нельзя добавить как упаковку — она всегда равна 1.',
    BATCH_SUPPLIER_MISMATCH: 'Партия «{batch}» поступила от другого поставщика.',
    BOT_SECRET_INVALID: 'Неверный ключ бота.',
    CATEGORY_OWN_PARENT: 'Категория не может быть родительской для самой себя.',
    CONSTRAINT_VIOLATED:
      'База данных отклонила это изменение. Обновите страницу и попробуйте ещё раз.',
    DEBTOR_REQUIRED: 'Для товара, выданного в долг, выберите сотрудника-должника.',
    DEDUCTION_EXCEEDS_DEBT: 'Сумма удержания ({deduction}) больше долга сотрудника ({owed}).',
    DEDUCTION_EXCEEDS_PAY:
      'Зарплата после авансов ({remaining}) меньше суммы удержания ({deduction}).',
    DEFAULT_UNIT_INVALID:
      'Единицей по умолчанию может быть только базовая единица или одна из упаковок товара.',
    EXPENSE_STATE: 'Текущий статус расхода не допускает это действие.',
    FOREIGN_KEY_IN_USE:
      'Связанная запись не найдена или ещё используется. Обновите страницу и попробуйте ещё раз.',
    INTERNAL_ERROR:
      'Произошла непредвиденная ошибка, она записана. Если проблема повторится, обратитесь к администратору.',
    INVALID_VALUE: 'Введённое значение слишком большое или неверное.',
    LOCATION_RETIRED: 'Блок «{location}» выведен из использования.',
    LOCATION_WRONG_WAREHOUSE: 'Блок «{location}» относится к другому складу.',
    LOGO_TOO_LARGE: 'Файл логотипа слишком большой.',
    OVERRIDE_REASON_REQUIRED: 'Укажите причину обхода ограничения.',
    PAYROLL_STATE: 'Текущий статус зарплаты не допускает это действие.',
    RECIPIENT_REQUIRED: 'Для внутреннего расхода укажите, кто получил товар.',
    SALARY_NEEDS_A_PERSON: 'Для расхода на зарплату выберите сотрудника.',
    SELF_DEACTIVATION: 'Нельзя деактивировать собственную учётную запись.',
    SELF_DELETION: 'Нельзя удалить собственную учётную запись.',
    SELF_ROLE_CHANGE: 'Нельзя изменить собственную роль.',
    SHOP_ALREADY_LINKED: 'Этот аккаунт Telegram уже привязан к другому магазину.',
    SHOP_NOT_LINKED: 'Магазин не привязан к Telegram.',
    STORE_REQUIRED: 'Для возврата от магазина выберите магазин.',
    SUPPLIER_PAYMENT_AGENT: 'В платеже поставщику агент не указывается.',
    SUPPLIER_REQUIRED: 'Для возврата поставщику выберите поставщика.',
    TELEGRAM_ALREADY_LINKED: 'Этот аккаунт Telegram уже привязан к другому пользователю.',
    TELEGRAM_NOT_LINKED: 'Аккаунт Telegram не привязан.',
    UNIT_LISTED_TWICE: 'Одна и та же единица указана дважды.',
    UNIT_NOT_CONFIGURED: 'У товара «{product}» нет такой единицы измерения.',
    UNKNOWN_ERROR: 'Произошла непредвиденная ошибка.',
  },
  password: {
    too_short: 'Минимум 8 символов',
    too_common: 'Слишком простой пароль',
    contains_username: 'Пароль не должен содержать логин',
    digits_only: 'Не может состоять только из цифр',
    mismatch: 'Пароли не совпадают',
  },
  pages: {
    forbidden: {
      title: 'Нет доступа',
      message: 'У вас нет прав на просмотр этой страницы.',
    },
    notFound: {
      title: 'Страница не найдена',
      message: 'Запрошенный адрес не существует.',
      back: 'Вернуться на главную',
    },
    dashboard: {
      placeholder: 'Основа готова. Модули добавляются поэтапно.',
      apiChecking: 'API: проверка…',
      apiDown: 'API: нет связи',
      apiUp: 'API: работает',
    },
  },
}

export default ru
